var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.offer)?_c('div',{staticClass:"document"},[_c('OfferPrintFirstPage',{attrs:{"offer":_vm.offer}}),_c('OfferPrintSecondPage',{attrs:{"offer":_vm.offer}}),_c('OfferPrintThirdPage',{attrs:{"offer":_vm.offer}})],1):_c('div',[_vm._v("Keine Daten vorhanden!")])
}
var staticRenderFns = []

export { render, staticRenderFns }